<template>
<div style="margin: 0 20px">
  <div style="height: 40px">
    <el-button size="small" type="primary" plain icon="el-icon-plus" @click="addCard()">添加</el-button>
  </div>
  <div style="height: 400px;padding-bottom: 20px">
    <el-table height="100%" :data="tableData" border highlight-current-row ref="singleTable">
      <el-table-column
        type="index"
        label="编号"
        width="70"
        align="center">
      </el-table-column>
      <el-table-column
        prop="elderly_card_id"
        label="卡号"
        min-width="90"
        align="center">
      </el-table-column>
      <el-table-column
        prop="person_status_code"
        label="状态"
        min-width="60"
        align="center">
      </el-table-column>
      <el-table-column
        prop="elderly_name"
        label="姓名"
        min-width="80"
        align="center">
      </el-table-column>
      <el-table-column
        prop="identity_number"
        label="身份证号"
        min-width="120"
        align="center">
      </el-table-column>
      <el-table-column
        prop="validity_date"
        label="有效期"
        min-width="120"
        align="center">
      </el-table-column>
      <el-table-column align="center" label="操作" width="80">
        <template slot-scope="scope">
          <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editCard(scope.row)"></i>
          <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delCard(scope.row)"></i>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="500px"
             :show-close="true" :close-on-click-modal="false" center class="all-open" append-to-body>
    <div class="title-top-alarm">
      <span>{{ titleCard }}</span>
      <div class="line-title"></div>
      <old-card :cardRow="cardRow" v-model="addEditShow" @updateTable="updateTable"></old-card>
    </div>
  </el-dialog>
</div>
</template>

<script>
import {queryelderlycardinfo, deleteelderlycardinfo} from '../../../api/yanglaoyuan'
import oldCard from './oldCard'
export default {
  name: 'oldCardList',
  props: {
    infoRow: {
      type: Object,
      default: null
    }
  },
  components: {oldCard},
  data () {
    return {
      oldPersonRow: '',
      tableData: [],
      titleCard: '',
      addEditShow: false,
      cardRow: {
        oldPersonRow: '',
        row: '',
        isAdd: true
      }
    }
  },
  created () {
    this.oldPersonRow = this.infoRow.oldPersonRow
    this.cardRow.oldPersonRow = this.infoRow.oldPersonRow
    this.getTableDataCard()
  },
  methods: {
    getTableDataCard () {
      if (this.oldPersonRow === '' || this.oldPersonRow.id === 0) {
        this.$message({
          message: '请先新增老人基本信息。',
          type: 'warning'
        })
        return
      }
      let data = {
        ep_id: this.oldPersonRow.id
      }
      queryelderlycardinfo(data).then(res => {
        this.tableData = res.data.elderlycard
      })
    },
    updateTable () {
      this.getTableDataCard()
    },
    addCard () {
      this.titleCard = '【' + this.oldPersonRow.elderly_name + '】添加老年卡'
      this.cardRow.isAdd = true
      this.cardRow.row = ''
      this.addEditShow = true
    },
    editCard (row) {
      this.titleCard = '【' + this.oldPersonRow.elderly_name + '】编辑老年卡'
      this.cardRow.isAdd = false
      this.cardRow.row = row
      this.addEditShow = true
    },
    delCard (row) {
      let name = row.elderly_card_id
      this.$confirm('此操作将永久删除该老年卡【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deleteelderlycardinfo(data).then(res => {
          this.$notify({title: '成功', message: '成功删除老年卡', type: 'success', duration: 2000})
          this.getTableDataCard()
        })
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/oldCardList.vue